"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 判断是否HTML元素
 * @return {Boolean} 是否HTML元素
 */
var isElement = function (o) {
    return o instanceof Element || o instanceof HTMLDocument;
};
exports.default = isElement;
//# sourceMappingURL=is-element.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-element.js
// module id = 1114
// module chunks = 37